import Component from "./InputText";
import * as sources from "./components";

export interface IInputTextExtensions {
    Label: typeof sources.Label;
    Left: typeof sources.Left;
    LeftAddon: typeof sources.LeftAddon;
    Right: typeof sources.Right;
    Hint: typeof sources.Hint;
    Bottom: typeof sources.Bottom;
}

export const InputText: typeof Component & IInputTextExtensions = Object.assign(
    Component,
    sources,
);

export type { InputTextPropsWithTextMask } from "./types";
